export default "__VITE_ASSET__hQo158lZ__"